import map from './map';
import Observable from './observable';
export default function combineLatest(combiner, streams) {
    if (streams.length === 0) {
        return Observable.defer(() => Observable.of(combiner([])));
    }
    if (streams.length === 1) {
        return map(
        // tslint:disable-next-line:ter-prefer-arrow-callback
        function combineLatestMap(value) {
            return combiner([value]);
        }, streams[0]);
    }
    // tslint:disable-next-line:ter-prefer-arrow-callback
    return new Observable(function factory(observer) {
        const observerFactory = createCombineLatestObserverFactory(streams, {
            next(values) {
                const combinedValue = combiner(values);
                observer.next(combinedValue);
            },
            error(error) {
                observer.error(error);
            },
            complete() {
                observer.complete();
            },
        });
        const subscriptions = streams.map((stream, index) => stream.subscribe(observerFactory(index)));
        return function unsubscribe() {
            // tslint:disable-next-line:no-increment-decrement
            for (let i = 0; i < subscriptions.length; i++) {
                subscriptions[i].unsubscribe();
            }
        };
    });
}
function createCombineLatestObserverFactory(streams, observer) {
    const PENDING = {};
    const currentValues = streams.map((stream) => PENDING);
    const hasCompleted = streams.map(() => false);
    let isReady = currentValues.length === 0;
    return function callbackForIndex(index) {
        return {
            next(value) {
                currentValues[index] = value;
                if (isReady || (isReady = !currentValues.some(isPending))) {
                    observer.next(currentValues.map((currentValue) => currentValue));
                }
            },
            error(error) {
                observer.error(error);
            },
            complete() {
                hasCompleted[index] = true;
                if (hasCompleted.every(Boolean)) {
                    observer.complete();
                }
            },
        };
    };
    function isPending(value) {
        return value === PENDING;
    }
}
//# sourceMappingURL=combine-latest.js.map